<template>
  <article class="detail-container" @click="isOpenAddress = false">
    <div class="btn-container">
      <button class="button left-btn mdi mdi-chevron-left mdi-24px" @click.stop="next()" :disabled="!enableNext"></button>
      <button class="button right-btn mdi mdi-chevron-right mdi-24px" @click.stop="prev()" :disabled="!enablePrev"></button>
      <span @click="clickCloseBtn()" class="close-btn mdi mdi-close mdi-24px"></span>
    </div>
    <div class="content-container">
      <section class="detail-info">
        <span class="item">日時:</span>
        <span class="content">{{formatTime(selectSended.created_at)}}</span>
      </section>
      <div class="address-wrapper" @click.stop="" :class="{'is-open': isOpenAddress}">
        <div class="closed-address" @click="isOpenAddress = true" v-if="!isOpenAddress">
          FROM
        </div>
        <div class="opend-address" v-if="isOpenAddress">
          <section class="detail-info">
            <span class="item">FROM:</span>
            <span class="content">{{selectSended.from_tel}}</span>
          </section>
        </div>
      </div>
      <section class="detail-message">
        <p>本文:</p>
        <div class="message-container"
          v-html="$sanitize(selectSended.sms_content.replace('\n', '<br>'))">
        </div>
      </section>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    selectSended: {
      type: Object,
      required: false,
      default: false
    },
    enablePrev: {
      type: Boolean,
      required: false,
      default: true
    },
    enableNext: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      isOpenAddress: false
    }
  },
  methods: {
    formatTime (createdAt) {
      return this.$moment(createdAt).format('YYYY/MM/DD H:mm:ss')
    },
    next(){
      this.$emit('clickNext')
    },
    prev(){
      this.$emit('clickPrev')
    },
    clickCloseBtn() {
      this.$emit('clickCloseBtn', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-container {
  text-align: left;
  position: absolute;
  z-index: 100;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #fefefe;
  width: 100%;
  height: 100%;
  padding: 8px;
  border-radius: 8px;
  .btn-container {
    display: flex;
    justify-content: flex-end;
    padding-bottom: 8px;
    .left-btn {
      width: 36px;
      height: 36px;
      margin-left: 8px;
    }
    .right-btn {
      width: 36px;
      height: 36px;
      margin-right: auto;
    }
    .close-btn {
      cursor: pointer;
    }
  }
  .content-container {
    padding: 0 8px;
  }
  .address-wrapper {
    transition: height 0.2s;
    height: 24px;
    overflow-y: hidden;
    &.is-open {
      height: 72px;
    }
    .closed-address {
      display: inline-block;
      border-radius: 3px;
      background-color: #e0e0e0;
      padding: 0px 2px;
      cursor: pointer;
      &:hover {
        background-color: #d0d0d0;
      }
    }
  }
  .detail-info {
    display: flex;
    .item {
      display: inline-block;
      width: 55px;
      margin-right: 8px;
    }
    .content {
      overflow-x: scroll;
      white-space: nowrap;
      flex: 1;
    }
  }
  .detail-message {
    margin-top: 16px;
    .message-container {
      padding: 8px;
      margin-top: 8px;
      height: 352px;
      overflow: auto;
      border: 1px solid gray;
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/articles/SMSDetail.vue